<template>
    <div v-if="userAccount && userAccount.role == 'manager'">
        <div class="inline">
            <div class='title'>
                <a href="#">
                    <include-svg :name="'icon-customers-sec'" />
                </a>
                <h2>Operators</h2>
            </div>
            <input-search class="input-search" v-model="search" :defaultVal="searchStartVal" @submit="sendSearchReq"
                @input="checkInput" />
            <div class="org-id">
                <p>Organization ID</p>
                <input-search placeholder='ORG ID' v-model="orgId" @submit="sendORGIDSearch" />
            </div>
            <btn-block :type="'grey-cut'" :text="'Export CSV report'" :icon="'icon-export'" @click="downloadCSV" />
            <a href="#" :ref="'link'"></a>
        </div>
        <div v-if="items.length > 0">
            <template v-if="!emptyState">
                <table v-if="viewPort == 'extraLarge'" class="sm-table sm-customers-table__desktop">
                    <thead class="sm-table__head">
                        <tr class="sm-txt-upper">
                            <th class="sm-table__head-item number">
                                Client ID
                            </th>
                            <th class="sm-table__head-item name">Org ID</th>
                            <th class="sm-table__head-item name">
                                level
                            </th>
                            <!-- <th class="sm-table__head-item date">
                    created at
                </th> -->
                            <th class="sm-table__head-item name">
                                Subdomain
                            </th>

                <th class="sm-table__head-item name">
                    Business Name
                </th>
                <th class="sm-table__head-item address">
                    Business Address
                </th>
                <th class="sm-table__head-item email">
                    Business Email
                </th>
                <th class="sm-table__head-item name">
                    Business Phone
                </th>
                 <th class="sm-table__head-item name">
                    Active Customers
                </th>
                <th class="sm-table__head-item name">
                    Inactive Customers
                </th>
                <th class="sm-table__head-item date">
                    Payment Gateway
                </th>
                
                 <th class="sm-table__head-item status sort">
                    Status
                </th>

                <th class="sm-table__head-item status sort">
                    White Labeling
                </th>


                            <th class="sm-table__head-item request">
                                <span>Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <item-operator v-for="item in items" :key="item.id" :item="item" :viewPort="viewPort"
                            @action="handleAction" />
                    </tbody>
                </table>
                <div v-else class="sm-mobile-table sm-customers-table__mobile">
                    <div class="sm-mobile-table">
                        <div class="sm-mobile-table-item header">
                            <div class="sm-mobile-table-item-row">
                                <div class="sm-mobile-table-item-row-th name">Client ID</div>
                                <div class="sm-mobile-table-item-row-th username">Name</div>

                                <div class="sm-mobile-table-item-row-th pmb sm-txt-center">Level</div>
                                <div class="sm-mobile-table-item-row-th status sm-txt-right"
                                    v-if="viewPort == 'medium' || viewPort == 'large'">Status</div>
                            </div>
                        </div>
                        <item-operator v-for="item in items" :key="item.id" :item="item" :viewPort="viewPort"
                            @action="handleAction" />
                    </div>
                </div>
                <paginate-block v-if="items.length" v-model="pager.onPage" :pages="pager.pages" :page="pager.page"
                    :onPage="pager.onPage" :morePages="morePages" :items="pager.items" @showMore="getMoreOperators()" />
            </template>
        </div>
        <empty-table v-else :icon="'icon-empty-new'" :text="'No operators to show'" :title="'Nothing here yet'" />
        <sm-spinner :show="showSpinner" />
    </div>
</template>
<script>
import PaginateBlock from '@/components/PaginateBlock';
import EmptyTable from '@/components/EmptyTable';
import ItemOperator from "./ItemOperator.vue"
import { mapActions, mapGetters } from 'vuex';
import InputSearch from '@/components/InputSearch';
import InputText from '@/components/InputText';
import { fetchOperatorsCSV } from '@/store/modules/operators/actions';
import CustomersItem from '@/views/admin/pages/customers/components/TableItem';
import ViewPort from '@/mixins/ViewPort';
import Spinner from '@/components/Spinner';

export default {
    name: 'test',
    components: {
        'paginate-block': PaginateBlock,
        'empty-table': EmptyTable,
        'item-operator': ItemOperator,
        'input-search': InputSearch,
        'input-text':InputText,
        'customers-item': CustomersItem,
        'sm-spinner': Spinner
    },
    data() {
        return {
            clients: [{ name: "hello" }],
            text: "mazen",
            prepareList: [],
            prepareMoreList: [],
            morePages: 0,
            checkAll: false,
            key: '',
            currentSort: 'id',
            currentSortDir: 'desc',
            pager: {
                page: 1,
                pages: 1,
                items: 1,
                onPage: 8
            },
            emptyState: false,
            search:'',
            searchStartVal: '',
            searchTimer: 0,
            searchTimerUpdate: 100,
            seachWait: 1000,
            orgId:'',
            operatorsList:[],
            showSpinner: false
        }
    },
    computed: {
        ...mapGetters({
            isMobile: 'isMobile',
            list: 'operators/list',
            more: 'operators/more',
            user:'auth/user',
            userAccount: 'account/userAccount',
        }),
        items() {
            return [...this.prepareList, ...this.prepareMoreList]
        }
    },
    created() {
        this.showSpinner=true;
        this.getUserAccount().then(({account}) => {
            if(account && account.role == 'manager'){
            let query = Object.assign({}, this.$route.query);
            this.pager.page = query.page || 1;
            this.pager.onPage = query.limit || 8;
            this.getOperators();
            this.searchTimer = setInterval(() => this.searchTimer += this.searchTimerUpdate, this.searchTimerUpdate);    
        }else {
            this.$router.push('/')
        }
        }).then(() => {
            this.showSpinner=false;
        }).catch(() => {
            this.showSpinner=false;
            this.$router.push('/')
        })
    },
    mixins: [ViewPort],
    methods: {
        ...mapActions({
            fetchOperators: 'operators/fetchOperators',
            fetchMoreOperators: 'operators/fetchMoreOperators',
            fetchOperatorsCSV: 'operators/fetchOperatorsCSV',
            getUserAccount: 'account/userData',
        }),
        getMoreOperators() {
            this.checkAll = false;
            this.morePages++;
            let query = Object.assign({}, this.$route.query);
            query.page = this.pager.page + this.morePages;
            query.limit = this.pager.onPage;

            if (query.order)
                query.order = JSON.parse(decodeURIComponent(query.order));
            this.fetchMoreOperators(query);
        },
        async getOperators() {
            this.checkAll = false;
            //this.morePages++;
            let query = Object.assign({}, this.$route.query);
            query.page = this.pager.page;
            query.limit = this.pager.onPage;

            if (query.order)
                query.order = JSON.parse(decodeURIComponent(query.order));
            this.fetchOperators(query);
        },
        sendSearchReq() {
            this.$router.push({
                query: {
                ...this.$route.query,
                ...{
                    search: this.search
                }
                }
            });
            },
        checkInput() {
            setTimeout(() => {
                if (this.searchTimer > this.seachWait) {
                    this.sendSearchReq();
                    this.searchTimer = 0;
                }
            }, this.seachWait);
            },
        sendORGIDSearch() {
            this.$router.push({
                query: {
                ...this.$route.query,
                ...{
                    org_id: this.orgId
                }
                }
            });
        },
        downloadCSV(){
            //this.showSpinner=true;
            this.fetchOperatorsCSV(this.$route.query).then((data)=>{
                let link = this.$refs.link;
                let encodedUri = encodeURI(`data:text/csv;charset=utf-8,${data}`);
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "result.csv");
                link.click();
              //  this.showSpinner = false;
            }).catch((error)=>{
             //   this.showSpinner = false;
                console.log(error);
            }) 
        },
        handleAction(){
            this.getOperators()
        },
        prepareOperators(operators) {
        return operators.map(item => {
            const temp = {...item};
            temp.popupOpen = false;
            temp.itemOpen = false;
            return temp;
        });
        },
        },
    watch: {
        list(val, oldVal) {
            this.pager.page = parseInt(this.list.page);
            this.pager.pages = this.list.total_pages;
            this.pager.items = this.list.total_count;
            this.pager.onPage = parseInt(this.$route.query.limit) || 8;
            if (!this.$route.query.order) {
                this.currentSort = 'id';
                this.currentSortDir = 'desc';
            }
            this.emptyState = this.list.clients.length == 0;
            this.prepareList = this.prepareOperators(this.list.clients);
        },
        more(val) {
            this.prepareMoreList = this.prepareOperators(val);
        },
        '$route.query'(val) {
            if (val.limit)
                this.pager.onPage = parseInt(val.limit);
            this.pager.page=val.page;
            this.getOperators();
        },
        orgId(val){
            this.sendORGIDSearch()
        },
    }
}
</script>
<style>
.inline{
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom:10px;
    margin-top:10px;
}
.title{
    margin-left:20px;
    width:60%;
    display: flex;
    align-items: center;
}
.title a{
    background-color:var(--sys);
    color: var(--white);
    height: 56px;
    width: 56px;
    margin-right: 11px;
    border-radius: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.input-search{
    margin-left:10px;
    height:40px;
    width:600px;
    vertical-align:middle;
}
.org-id{
    width:400px;
}


.sm-table__head-item.name {
    max-width: 150px;
    width: fit-content;
}


.sm-table__head-item.number {
    width: fit-content;
}

.sm-table__head-item.address {
    width: 200px;
}

.sm-table__head-item.email {
    max-width: 150px;
    width: fit-content;
}



.sm-table > tbody > tr > td {
    word-break: break-all;
}
</style>